export function shopRequest(state ={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SHOP_START":           
        case "UPDATE_SHOP_START":           
        case "FETCH_SHOPS_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_SHOP_FULFILLED":           
        case "UPDATE_SHOP_FULFILLED":           
        case "FETCH_SHOPS_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true ,
                error:null
            }    
        case "CREATE_SHOP_ERROR":
        case "UPDATE_SHOP_ERROR":
        case "FETCH_SHOPS_ERROR":
            return {
                ...state,
                fetching:false, 
                fetched:false, 
                error:payload
            }
        default:
            return state;
    }
    
}